/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    MenuItem,
    TextField,
    Toolbar,
} from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import React from 'react';
import { IFormularioResolucionesFacturacionesVistaProps } from '../interfaces';

const FormularioResolucionesFacturacionesVista: React.FunctionComponent<IFormularioResolucionesFacturacionesVistaProps> = ({
    alCambiarValor,
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    resolucionesFacturaciones,
    entidadesResoluciones,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'resolucionesFacturaciones.agregarResolucionesFacturaciones'
                                : 'resolucionesFacturaciones.modificarResolucionesFacturaciones'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="resolucionesFacturaciones.bodegaDescripcion" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="BodegaId"
                        select
                        onChange={cambiarInfoFomulario}
                        required
                        value={resolucionesFacturaciones.BodegaId}
                    >
                        {entidadesResoluciones.bodegas.filter((x) => x.Estado === 1).length === 0 ? (
                            <MenuItem value="">
                                <Texto id="label.sinRegistros" />
                            </MenuItem>
                        ) : (
                            entidadesResoluciones.bodegas
                                .filter((x) => x.Estado === 1)
                                .map(({ BodegaDescripcion, BodegaId }) => (
                                    <MenuItem key={BodegaId} value={BodegaId}>
                                        {BodegaDescripcion}
                                    </MenuItem>
                                ))
                        )}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={
                            <Texto id="resolucionesFacturaciones.descripcionResolucionFacturacion" display="inline" />
                        }
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="DescripcionResolucionFacturacion"
                        onChange={cambiarInfoFomulario}
                        required
                        value={resolucionesFacturaciones.DescripcionResolucionFacturacion}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="resolucionesFacturaciones.facturaInicio" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="FacturaInicio"
                        onChange={cambiarInfoFomulario}
                        required
                        value={resolucionesFacturaciones.FacturaInicio}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="resolucionesFacturaciones.facturaFin" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="FacturaFin"
                        onChange={cambiarInfoFomulario}
                        required
                        value={resolucionesFacturaciones.FacturaFin}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="resolucionesFacturaciones.facturaActual" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="FacturaActual"
                        onChange={cambiarInfoFomulario}
                        required
                        value={resolucionesFacturaciones.FacturaActual}
                    />
                </Grid>

                <Grid item md={6} xs={12}>
                    <KeyboardDatePicker
                        format="DD/MM/YYYY"
                        name="FechaInicio"
                        fullWidth
                        required
                        label={<Texto id="resolucionesFacturaciones.fechaInicio" />}
                        autoOk
                        variant="inline"
                        onChange={(fecha: any) =>
                            // tslint:disable-next-line:no-object-literal-type-assertion
                            alCambiarValor({ target: { name: 'FechaInicio', value: fecha } } as React.ChangeEvent<
                                HTMLInputElement
                            >)
                        }
                        value={resolucionesFacturaciones.FechaInicio}
                    />
                </Grid>
                <Grid item md={6} xs={12}>
                    <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        format="DD/MM/YYYY"
                        name="FechaFin"
                        fullWidth
                        required
                        label={<Texto id="resolucionesFacturaciones.fechaFin" />}
                        onChange={(fecha: any) =>
                            // tslint:disable-next-line:no-object-literal-type-assertion
                            alCambiarValor({ target: { name: 'FechaFin', value: fecha } } as React.ChangeEvent<
                                HTMLInputElement
                            >)
                        }
                        value={resolucionesFacturaciones.FechaFin}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={Number(resolucionesFacturaciones.Estado) === 1 ? true : false}
                                onChange={cambiarInfoFomulario}
                            />
                        }
                        label={<Texto id="perfil.estado" display="inline" />}
                        name="Estado"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            {tipoFormulario !== TipoFormulario.Visualizacion ? (
                <div>
                    <Grid container justifyContent="flex-end" spacing={2}>
                        <Grid item>
                            <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                                <Texto id="boton.cancelar" />
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button onClick={accionCrearEditar} color="primary" variant="contained">
                                <Texto id="boton.guardar" />
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            ) : (
                <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                    <Texto id="boton.cerrar" />
                </Button>
            )}
        </DialogActions>
    </Dialog>
);

export default FormularioResolucionesFacturacionesVista;
